module.exports = __webpack_public_path__ + "static/media/shirts6.bca71fe9.jpg";